import axios from "axios";
import { CANCEL_SUBSCRIPTION_URL } from "../utils";

export const cancelSubscription = async () => {
  return await axios.post(CANCEL_SUBSCRIPTION_URL);
};
